'use strict';

var Promise = require('bluebird');

function fetch (url) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html',
      cache: true,
      beforeSend: function (jqXHR, settings) {
        jqXHR.url = settings.url;
      }
    })
      .then(resolve, (jqXHR, textStatus, errorThrown) => {
        reject(new Error(`Error: ${textStatus} : ${errorThrown}`));
      });
  });
}

const cache = {};

function fetchWithCache (url) {
  if (!cache[url]) {
    cache[url] = fetch(url);
  }
  return cache[url];
}

module.exports = fetchWithCache;
